"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getToken() {
    return sessionStorage.getItem("ltiToken");
}
exports.default = getToken;
